module.exports = __webpack_public_path__ + "img/_ABS9695.3c18a16b.jpg";